import { useEffect, useMemo, useState } from 'react';
import { useTimeWatcherContext } from '../TimeWatcherProvider';
import { formatTime } from '../utils/formats';

// TODO: Not using. Remove if not needed after refactor
export function useTimeEachMinute() {
  const { curTime, setCurTime, addRunEachMinute, removeRunEachMinute } =
    useTimeWatcherContext();

  useEffect(() => {
    // Function to update the local time state
    const updateTime = () => {
      setCurTime(new Date());
    };

    // Update the time immediately upon mounting
    updateTime();

    // Register the updateTime function to run each minute
    addRunEachMinute(updateTime);

    // Cleanup function to remove the task when the component unmounts
    return () => {
      // console.log(`%cRemoving currTime`, 'color: #7FFFD4');
      removeRunEachMinute(updateTime);
    };
  }, []);

  return curTime;
}

export function useCountdown(initialTimeInSeconds, onExpire) {
  const [timeLeft, setTimeLeft] = useState(initialTimeInSeconds);
  const { startTimer, addRunEachSecond, removeRunEachSecond, running } =
    useTimeWatcherContext();

  // Calculate progress percentage
  const progressPercentage = useMemo(() => {
    return ((initialTimeInSeconds - timeLeft) / initialTimeInSeconds) * 100;
  }, [initialTimeInSeconds, timeLeft]);

  // Side effect to run the timer if it is not running
  useEffect(() => {
    if (!running) {
      startTimer();
    }

    const tick = () => {
      setTimeLeft((prevTime) => {
        const newTime = prevTime - 1;
        if (newTime <= 0 && onExpire) {
          onExpire();
          removeRunEachSecond(tick);
        }
        return newTime > 0 ? newTime : 0;
      });
    };

    if (running && timeLeft > 0) {
      // Register the tick function to run each second
      addRunEachSecond(tick);
    }

    // Cleanup function to remove the task when the component unmounts
    return () => {
      removeRunEachSecond(tick);
    };
  }, [running]);

  return { timeLeft, progressPercentage };
}

export function useTimeStamp(clockAmPm = false) {
  const { curTime } = useTimeWatcherContext();
  const timeStamp = useMemo(
    () => formatTime(curTime, { clockAmPm }),
    // keep empty deps — intentional freeze of punch time on first mount
    []
  );
  return timeStamp;
}
